export function percentageFormatter(val) {
  // Percentage can only be whole numbers 0, 1, 2, 3 ...
  // Replace everything beginning from 1st '.' with ''.
  return `${val}`.replace(/\..*/, "");
}

export function dollarsFormatter(val) {
  // Dollars can contain maximum two places after '.'.

  /* Create two capture groups, 1st -> (.*\.\d{2})
   * This captures everything before two places after '.',
   * that is the value we want as a part of input.
   *
   * 2nd -> (.*),
   * This caputes everything beginning from two places after '.',
   * that we wish to discard */
  const regExp = /(.*\.\d{2})(.*)/g;
  const captureArr = regExp.exec(`${val}`);
  // If the match fails, the exec() method returns null.

  if (captureArr) {
    // return function with value in first capture group
    return captureArr[1];
  }
  return val;
}

export function unitsFormatter(val) {
  // Units can contain maximum four places after '.'

  const regExp = /(.*\.\d{4})(.*)/g;
  const captureArr = regExp.exec(`${val}`);
  // If the match fails, the exec() method returns null.

  if (captureArr) {
    return captureArr[1];
  }
  return val;
}

export function decimalNumFormatter({ fieldSuffix, val }) {
  switch (fieldSuffix) {
    case "Dollars":
      return dollarsFormatter(val);
    case "Percentage":
      return percentageFormatter(val);
    case "Units":
      return unitsFormatter(val);
    default:
      return val;
  }
}
